import React, { useState } from 'react';
// Imports pour Swiper
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, A11y, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

// Imports pour la Lightbox
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";

// Notre CSS personnalisé
import './ImageCarousel.css';

function ImageCarousel({ images }) {
  const [open, setOpen] = useState(false);
  const [index, setIndex] = useState(0);

  const handleSlideClick = (slideIndex) => {
    setIndex(slideIndex);
    setOpen(true);
  };

  return (
    <div className="image-carousel-container full-width">
      <Swiper
        modules={[Navigation, Pagination, A11y, Autoplay]}
        slidesPerView={1.25}
        spaceBetween={15}
        centeredSlides={true}
        loop={true}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
        navigation
        pagination={{ clickable: true }}
        className="my-swiper"
        breakpoints={{
          // à partir de 768px de large (tablettes)
          768: {
            slidesPerView: 2,
            spaceBetween: 20,
            centeredSlides: true, // MODIFIÉ ICI
          },
          // à partir de 1024px de large (ordinateurs)
          1024: {
            slidesPerView: 3,
            spaceBetween: 30,
            centeredSlides: true, // MODIFIÉ ICI
          },
        }}
      >
        {images.map((image, i) => (
          <SwiperSlide key={i} onClick={() => handleSlideClick(i)}>
            <div className="slide-content">
              <img src={image.src} alt={image.alt} />
              <div className="slide-overlay">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/></svg>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      <Lightbox
        open={open}
        close={() => setOpen(false)}
        slides={images}
        index={index}
      />
    </div>
  );
}

export default ImageCarousel;